import { BindingEngine, PropertyObserver } from 'aurelia-binding';

declare module 'aurelia-binding' {
  interface BindingEngine {
    /** @deprecated Please use a typesafe propertyObserverEx instead */
    // eslint-disable-next-line @typescript-eslint/ban-types
    propertyObserver(obj: Object, propertyName: string): PropertyObserver;
    propertyObserverEx<T>(obj: T, propertyName: keyof T): PropertyObserver;
  }
}

BindingEngine.prototype.propertyObserverEx = function (this: BindingEngine, obj, propertyName) {
  return this.propertyObserver(obj, propertyName as any as string);
};
